import React from "react"
import clsx from "clsx"

type LogoProps = {
  className?: any
}

const HeaderLogo = ({ className }: LogoProps) => (
  <div className={clsx("flex-shrink-0", className)}>
    <img className="w-auto h-10" src="/logo.png" alt="Homeschool Boss Logo" />
  </div>
)
export default HeaderLogo
